module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_landing) ? _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.set_view == 'product') ? _c('div', [_c('div', {
    staticStyle: {
      "position": "absolute",
      "z-index": "9 !important",
      "top": "1em",
      "margin-left": "1em"
    }
  }, [_c('a', {
    staticClass: "mini-btn",
    staticStyle: {
      "text-decoration": "none",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setView('')
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "z-index": "2 !important"
    }
  }, [_c('product-view', {
    attrs: {
      "product_data": _vm.product
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pager pager-clear-sticky"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-top": "-2em",
      "padding-top": "2.5em",
      "padding-bottom": "2em",
      "background": "#FF0040"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.categories && (_vm.categories.length > 1)) ? _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "0.3em"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(category) {
    return _c('li', [_c('div', {
      staticClass: "card-hflat wc3"
    }, [_c('div', {}, [_c('p', {}, [_vm._v(_vm._s(category.category_name))])])])])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#ffffff",
      "margin-top": "-3em",
      "border-top-left-radius": "22px",
      "border-top-right-radius": "22px"
    }
  }, [_c('div', {
    staticClass: "category-slide csl3",
    staticStyle: {
      "padding-top": "2.7em"
    }
  }, [_c('ul', _vm._l((_vm.market_trending), function(product, index) {
    return _c('li', [_c('div', [_c('a', {
      on: {
        "click": function($event) {
          _vm.viewProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('p', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("@" + _vm._s(product.product_business_ownername))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "clear": "both"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])])])])])])
  }))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "category-slide csl3",
    staticStyle: {
      "margin-top": "0.3em"
    }
  }, [_c('ul', _vm._l((_vm.market.business_markets), function(business, index) {
    return _c('li', [_c('div', [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + business.business_username
      }
    }, [_c('div', {}, [_c('div', {
      staticClass: "card-avatar-square"
    }, [_c('img', {
      attrs: {
        "src": business.business_brand_image
      }
    })])]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(business.business_name)), _c('br'), _c('span', [_vm._v("@" + _vm._s(business.business_username))])])])])])])])
  }))]), _vm._v(" "), _vm._m(4)])])])])]), _vm._v(" "), _c('component-footer')], 1)]) : _c('div', [_c('component-landing')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-angle-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 3em 0 5em"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "search"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ocl",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn sp-button-02 sp-button-02-lt"
  }, [_vm._v("see all")])]), _vm._v(" "), _c('li', [_c('p')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ocl"
  }, [_c('li', [_c('p', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("     ")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Order from stores")])]), _vm._v(" "), _c('li', [_c('p', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("     ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ocl"
  }, [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn sp-button-02 sp-button-02-lt"
  }, [_vm._v("find store")])]), _vm._v(" "), _c('li', [_c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b3351e3"}!./src/pages/Timeline/template.html
// module id = 421
// module chunks = 0